'use client';

import { useTransition } from 'react';

import cx from 'classnames';
import { type Asyncify } from 'type-fest';

import LoadingIcon from '~/ui/assets/icons/loading.svg';

import styles from './async.module.scss';
import { Button, type ButtonProps } from '../button';

export interface AsyncButtonProps extends Omit<ButtonProps, 'onClick' | 'aria-busy'> {
  onClick?: Asyncify<NonNullable<ButtonProps['onClick']>>;
}

export function AsyncButton({ onClick, className, children, ...props }: AsyncButtonProps) {
  const [isPending, startTransition] = useTransition();

  return (
    <Button
      {...props}
      onClick={event => {
        startTransition(async () => {
          await onClick?.(event);
        });
      }}
      className={cx(className, styles.async)}
      aria-busy={isPending}
    >
      <div className={styles.children}>{children}</div>
      {isPending && <LoadingIcon className={styles.loadingIcon} aria-label="Loading" />}
    </Button>
  );
}
